import {
  CANDIDACY_ERR,
  CANDIDACY_REMOVE,
  CREATE_ERR,
  GET_ACCEPT_CANDIDACY,
  GET_ALL_CANDIDAT,
  GET_ALL_COMMANDE,
  GET_ALL_ERR,
  GET_ALL_PARTENAIRE,
  GET_ALL_USER,
  REMOVE_ERR,
  REMOVE_SERVICE,
  REMOVE_USER,
  UPDATE_ALL_USER,
} from '../constants'

const initial = {
  item: null,
}

export const adminReducer = (state = initial, action) => {
  const { type, payload } = action

  switch (type) {
    case GET_ALL_USER:
    case GET_ALL_PARTENAIRE:
    case GET_ALL_CANDIDAT:
    case GET_ALL_COMMANDE:
      return { ...state, item: payload }
    case GET_ALL_ERR:
      return {
        ...state,
        error: payload,
      }

    case REMOVE_SERVICE:
    case REMOVE_USER:
      const newUser = state?.item?.filter((i) => {
        return i._id !== payload
      })
      return {
        ...state,
        item: newUser,
      }
    case UPDATE_ALL_USER:
      const newAdmin = [...state.item, payload]
      return { ...state, item: newAdmin }
    case REMOVE_ERR:
    case CREATE_ERR:
      return {
        ...state,
        err: payload,
      }
    case CANDIDACY_REMOVE:
    case GET_ACCEPT_CANDIDACY:
      const newArrCand = state?.item?.filter((obj) => {
        return obj._id !== payload
      })
      return {
        ...state,
        item: newArrCand,
      }
    case CANDIDACY_ERR:
      return {
        ...state,
        err: payload,
      }
    default:
      return state
  }
}
